"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeJetpack = void 0;
const CTGGameModeFlappy_1 = require("./CTGGameModeFlappy");
class CTGGameModeJetpack extends CTGGameModeFlappy_1.CTGGameModeFlappy {
    constructor(generator, speed) {
        super(generator, speed);
        this.gravity = 15;
        this.boost = this.gravity * 2.5;
    }
    reset() {
        super.reset();
        this.gravity_down = true;
    }
    clicked(scene, mx, my) {
        // Intentionally left blank to avoid parent game mode behavior.
    }
    update_position(now, delta, difficulty, mx, my, mdown) {
        const delta_s = delta / 1000;
        const diff_mod = delta_s * (1 + this.difficulty);
        this.bird_vel += this.gravity * diff_mod - (mdown ? this.boost * diff_mod : 0);
        this.bird.move(this.bird.x, this.bird.y + this.bird_vel * diff_mod);
    }
}
exports.CTGGameModeJetpack = CTGGameModeJetpack;
